import React from 'react'
import { ExportButton, Page, Text, Table } from '@fielded/shared-ui'

import ExportImportCard from '../../../../../van-shared/components/ExportImportCard'

const COLUMNS = [
  {
    key: 'date',
    header: 'date',
    dataKey: 'date',
    disableSort: true,
    headerClassName: 'inbound-shipments-table-column__date'
  },
  {
    key: 'destinationWarehouseCode',
    header: 'destinationWarehouseCode',
    dataKey: 'destinationWarehouseCode',
    disableSort: true
  },
  {
    key: 'productId',
    header: 'productId',
    dataKey: 'productId',
    disableSort: true
  },
  {
    key: 'batchNo',
    header: 'batchNo',
    dataKey: 'batchNo',
    disableSort: true
  },
  {
    key: 'manufacturer',
    header: 'manufacturer',
    dataKey: 'manufacturer',
    disableSort: true
  },
  {
    key: 'expiry',
    header: 'expiry',
    dataKey: 'expiry',
    disableSort: true,
    headerClassName: 'inbound-shipments-table-column__date'
  },
  {
    key: 'quantity',
    header: 'quantity',
    dataKey: 'quantity',
    disableSort: true
  },
  {
    key: 'programId',
    header: 'programId',
    dataKey: 'programId',
    disableSort: true
  },
  {
    key: 'funderId',
    header: 'funderId',
    dataKey: 'funderId',
    disableSort: true
  },
  {
    key: 'productCodeAlias',
    header: 'productCodeAlias',
    dataKey: 'productCodeAlias',
    disableSort: true
  }
]

const PSMInboundShipmentsOverviewDownload = ({
  country,
  isDownloading,
  onDownloadTemplate
}) => {
  const destinationWarehouseCode = country === 'ng' ? 'NG-EPN-JOS' : 'KE-EPN-CHAK'
  const programId = `program:${country}-epn`
  const funderId = `funder:${country}-epn`

  const rows = [
    {
      date: '11-03-2025',
      destinationWarehouseCode: destinationWarehouseCode,
      productId: 'product:EPN-AMO001',
      batchNo: '88087',
      manufacturer: 'unknown',
      expiry: '11-01-2029',
      quantity: '8',
      programId: programId,
      funderId: funderId,
      productCodeAlias: 'epn'
    },
    {
      date: '11-03-2025',
      destinationWarehouseCode: destinationWarehouseCode,
      productId: 'product:EPN-AMO002',
      batchNo: '88017',
      manufacturer: 'unknown',
      expiry: '01-01-2028',
      quantity: '100',
      programId: programId,
      funderId: funderId,
      productCodeAlias: 'epn'
    },
    {
      date: '11-03-2025',
      destinationWarehouseCode: destinationWarehouseCode,
      productId: 'product:EPN-AMO003',
      batchNo: '88000',
      manufacturer: 'unknown',
      expiry: '01-01-2028',
      quantity: '10',
      programId: programId,
      funderId: funderId,
      productCodeAlias: 'epn'
    }
  ]

  return (
    <Page.Panel>
      <ExportImportCard
        title='Download shipment template'
        description='Click on the button below to download the Excel template for your shipment import. Ensure you do not modify the structure of the template to avoid upload errors.'
        button={
          <ExportButton
            buttonText='Download template'
            loading={isDownloading}
            filename={`shipments-${new Date().toJSON()}.xlsx`}
            onExport={onDownloadTemplate}
          />
        }
      >

        <Text>Here is an example how the Excel file should look:</Text>
        <div className='inbound-shipments-upload-example__wrapper vs-u-margin-bottom'>
          <Table
            entries={rows}
            columns={COLUMNS}
            headerTextStyle='lowercase'
          />
        </div>
        <Text><Text tag='span' bold>date</Text> column contains the date of the shipment in format <Text tag='span' bold>"dd-mm-yyyy"</Text> or <Text tag='span' bold>"dd/mm/yyyy"</Text></Text>
        <Text><Text tag='span' bold>destination warehouse code</Text> column contains the destination warehouse code.</Text>
        <Text><Text tag='span' bold>product Id</Text> column contains the product id</Text>
        <Text><Text tag='span' bold>batch no</Text> column contains the batch number</Text>
        <Text><Text tag='span' bold>manufacturer</Text> column contains the product manufacturer</Text>
        <Text><Text tag='span' bold>expiry</Text> column contains the batch expiry date in format <Text tag='span' bold>"dd-mm-yyyy"</Text> or <Text tag='span' bold>"dd/mm/yyyy"</Text></Text>
        <Text><Text tag='span' bold>quantity</Text> column contains the quantity to be delivered</Text>
        <Text><Text tag='span' bold>program Id</Text> column contains the identifier of the program</Text>
        <Text><Text tag='span' bold>funder Id</Text> column contains the identifier of the funder</Text>
        <Text><Text tag='span' bold>product code alias</Text> column contains the alternate product code</Text>
      </ExportImportCard>
    </Page.Panel>
  )
}

export default PSMInboundShipmentsOverviewDownload
